export default __webpack_public_path__ + "static/media/process.438e46a7.svg";